﻿import {UIText} from "./Tools/Base/UIText";
import {UISprite} from "./Tools/Base/UISprite";
import {Core} from "../Base/Core";
import {UIBonusTimer} from "./UIBonusTimer";
import {TUTORIAL_STATE} from "../Game/GameManager";

class CircleProgress extends UISprite {
    Awake() {
        super.Awake();

        this.back = this.addChild(new UISprite("circle-simple"));
        this.back.anchor.set(0, 0);
        this.back.tint = 0X2E318A;
        this.back.alpha = 0.3;

        this.front = this.addChild(new UISprite("circle-simple"));
        this.front.anchor.set(0, 0);
        this.front.tint = 0X49B7B8;

        this.front.mask = this.front.addChild(
            new PIXI.Graphics().clear()
                .beginFill(0xFFFFFF, 1)
                .drawRect(0, 0, this.front.texture.width, this.front.texture.height)
        );
    }

    get value() {
        return (this.front.texture.height - this.front.mask.y) / this.front.texture.height;
    }

    set value(val) {
        val = Math.max(0, Math.min(1, val || 0));
        this.front.mask.y = this.front.texture.height * (1 - val);
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);
        // this.back.position.set(rect.width * 0.5, rect.height * 0.5);
        this.back.scale.set(Math.min(
            rect.width / this.back.texture.width,
            rect.height / this.back.texture.height
        ));
        // this.front.position.copyFrom(this.back.position);
        this.front.scale.copyFrom(this.back.scale);
    }
}

export class UIBubbleProgress extends UISprite {

    // Start is called before the first frame update
    Awake() {
        super.Awake();
        this.progressBar = this.addChild(new CircleProgress());
        this.bubbleProgressField = this.addChild(new UIText());
        this.fullField = this.addChild(new UIText(Core.Localizator.Get("bubble_full"), {fill: 0xFF0000}));
        this.bonusTimer = this.addChild(new UIBonusTimer());
    }

    Update() {
        if (!Core.Player.Initialized) return;
        this.SetActive(!GameManager.tutorialState || GameManager.tutorialState > TUTORIAL_STATE.BUBBLE3);
        this.updateBubbleProgressUI();
        this.bonusTimer.Update(Core.Player.Timers.bubbleBoosterTimerId);
    }

    updateBubbleProgressUI() {
        let epochId = Core.Player.PlanetsSave.CurrentPlanet.StartEpoch;
        let isBubbleFull = !GameManager.gameController.epochById.get(epochId).EnoughSpaceForSpawn;

        let bubbleProgress = isBubbleFull
            ? 1
            : Math.max(0, Math.min(1, GameManager.timeFromLastBubbleSpawn / GameManager.bubbleSpawnPeriod))
        ;

        this.fullField.SetActive(isBubbleFull);
        this.bubbleProgressField.SetActive(!isBubbleFull);
        this.bubbleProgressField.text = Math.ceil((1 - bubbleProgress) * GameManager.bubbleSpawnPeriod);

        this.progressBar.value = bubbleProgress;
    }

    fitLayout(rect) {
        rect = rect.clone();
        this.position.copyFrom(rect);

        rect.x = 0; rect.y = 0;
        let progressRect = rect.clone();
        progressRect.height = progressRect.width;
        this.progressBar.fitLayout(progressRect);

        let labelRect = rect.clone();
        labelRect.height = rect.height * 0.4;
        labelRect.y = rect.height - labelRect.height;

        let bonusTimerRect = new PIXI.Rectangle(rect.width * 0.8, 0, rect.width * 0.2, rect.height * 0.2);
        this.bonusTimer.fitLayout(bonusTimerRect);

        this.bubbleProgressField.fitLayout(labelRect);
        this.fullField.fitLayout(labelRect);
    }

}
